// extracted by mini-css-extract-plugin
export default {"table":"Stages_table__IXmx9","row":"Stages_row__EewBA","iconButton":"Stages_iconButton__Ewoqq"};